import React, { useState } from "react";
import axios from "axios";
import config from "../../../../config/environment";
import Menu from "../../elements/Menu/menu";
import CheckAuth from "../../elements/checkAuth";
import './CPATable.css';

function TableComponent(props) {
    let {
        cashbackArr,
        setCashbackArr
    } = props

    const handleInput = (e, index) => {
        cashbackArr[index].cashbackToken = e.target.value
        setCashbackArr([...cashbackArr])
    }

    const handleInputTx = (e, index) => {
        cashbackArr[index].txHash = e.target.value
        setCashbackArr([...cashbackArr])
    }

    const handleRemove = (index) =>{
        cashbackArr.splice(index, 1)
        setCashbackArr([...cashbackArr])
    }

    return (
        <div className="CPATable_table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th >CB Token</th>
                            <th >CB Balance</th>
                            <th >CPA Balance</th>
                            <th >TX Hash</th>
                            <th >Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            cashbackArr.map((el, index) => {
                                return (
                                    <tr>
                                        <td> <input type="text" onChange={(e)=>{handleInput(e, index)}} value={cashbackArr[index].cashbackToken}/> </td>
                                        <td>{cashbackArr[index].cbBalance || '---'}</td>
                                        <td>{cashbackArr[index].cpaBalance || '---'}</td>
                                        <td><input type="text" onChange={(e)=>{handleInputTx(e, index)}} value={cashbackArr[index].txHash}/></td>
                                        <td><button onClick={()=>{handleRemove(index)}}>REMOVE</button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
    )
}

export default function CPATable() {
    let [cashbackArr, setCashbackArr] = useState([{
        cashbackToken: '', 
        cbBalance: '', 
        cpaBalance: '',
        txHash: ''
    }])
    
    async function getBalancesHandler() {
        let query = config.cashbackUrl + "/get-balances"

        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }

        let reqBody = {
            token2fa,
            cashbackTokensArray: cashbackArr.map(data => data.cashbackToken)
        }

        await axios.post(query, reqBody).then(
            (resp) => {
                if (resp.data.status === 'fail') {
                    return alert(resp.data.message);
                }

                for (let i = 0; i < cashbackArr.length; i++){
                    for (let j = 0; j < resp.data.data.balances.length; j++) {
                        if (cashbackArr[i].cashbackToken.toLowerCase() === resp.data.data.balances[j].cashbackToken.toLowerCase()) {
                            cashbackArr[i].cbBalance = resp.data.data.balances[j].cbBalance
                            cashbackArr[i].cpaBalance = resp.data.data.balances[j].cpaBalance
                        }
                    }
                }
                setCashbackArr([...cashbackArr])
            }
        )
    }

    function addRecordHandler() {
        setCashbackArr([{
            cashbackToken: '', 
            cbBalance: '', 
            cpaBalance: '',
            txHash: ''
        }, ...cashbackArr])
    }

    function makeReqBody(arr) {
        return arr.map(el =>{
            return {
                cashbackToken: el.cashbackToken,
                txHash: el.txHash || null
            }
        })
    }

    async function resetBalance(type) {
        let query = config.cashbackUrl + (type === 'CPA' ? '/set-zero-cpa-balance' : '/set-zero-cashback');

        const token2fa = prompt('Enter 2FA');
        if (!token2fa) {
            alert('Invalid 2FA');
            return;
        }

        let reqBody = {
            token2fa,
            cashbackTokensDataArray: makeReqBody(cashbackArr)
        }

        await axios.post(query, reqBody).then(
            (resp) => {
                if (resp.data.data.message === 'success') {
                    alert('Success');
                    for (let i = 0; i < cashbackArr.length; i++) {
                        if (type === 'CPA') {
                            cashbackArr[i].cpaBalance = '';
                        } else {
                            cashbackArr[i].cbBalance = '';
                        }
                    }
                    setCashbackArr([...cashbackArr])
                } else {
                    return alert(resp.data.message);
                }
            }
        )
    }

  return (
    <>
      <CheckAuth />
      <Menu />
    <div className='CPATable_main_wrap'>
        <div className='CPATable_btn_wrap'>
            <button onClick={getBalancesHandler} className='CPATable_button'>Get balances</button>
            <button onClick={addRecordHandler} className='CPATable_button'>Add record</button>
        </div>
        <div className="CPATable_scroll_wrapper">
            <TableComponent cashbackArr = {cashbackArr} setCashbackArr = {setCashbackArr}/>
        </div>
        <div className='CPATable_btn_wrap_floating'>
            <button onClick={() => {resetBalance('CASHBACK')}} className='CPATable_button'>Reset cb balance</button>
            <button onClick={() => {resetBalance('CPA')}} className='CPATable_button'>Reset cpa balance</button>
        </div>
    </div>
    </>
  );
}
